"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  ELEMENT: 1,
  TEXT: 3,
  COMMENT: 8
};


//////////////////
// WEBPACK FOOTER
// ../~/html2react/lib/node-type.js
// module id = 44
// module chunks = 0